import { makeStyles } from '@material-ui/core';

const useStyles = makeStyles(() => ({
	header: {
		display: 'flex',
		alignItems: 'center',
		justifyContent: 'flex-end',
	},
	action: {
		fontSize: 12,
	},
	title: {
		fontSize: 18,
		fontWeight: 600,
	},
}));

export default useStyles;
